import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/unittype/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/unittype/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.unittype.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUnitTypeAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_TYPE_ASYNC, vo });

            EditService.saveUnitType(
                vo,
                response => {
                    dispatch(Actions.saveUnitTypeSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUnitTypeFailure(error));
                }
            );
        };
    },

    saveUnitTypeSuccess: data => ({
        type: ActionTypes.SAVE_UNIT_TYPE_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_TYPE_ASYNC,
        data
    }),

    saveUnitTypeFailure: error => ({
        type: ActionTypes.SAVE_UNIT_TYPE_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_TYPE_ASYNC,
        error
    }),

    createUnitType: () => ({
        type: ActionTypes.CREATE_UNIT_TYPE
    }),

    uploadPhotoAsync: (file, id) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPLOAD_PHOTO_ASYNC, file, id });

            EditService.uploadPhoto(
                file,
                id,
                response => {
                    dispatch(Actions.uploadPhotoSuccess(response));
                },
                error => {
                    dispatch(Actions.uploadPhotoFailure(error));
                }
            );
        };
    },

    uploadPhotoSuccess: data => ({
        type: ActionTypes.UPLOAD_PHOTO_SUCCESS,
        parentType: ActionTypes.UPLOAD_PHOTO_ASYNC,
        postReducer: uploadPhotoSuccessPostReducer,
        data
    }),

    uploadPhotoFailure: error => ({
        type: ActionTypes.UPLOAD_PHOTO_FAILURE,
        parentType: ActionTypes.UPLOAD_PHOTO_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unitType: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, unitType: data.unitType };
};

const uploadPhotoSuccessPostReducer = (state, { data }) => {
    const { unitType } = state;
    return { ...state, unitType: { ...unitType, photo: data.virtualPath, imageUrl: data.absoluteUrl } };
};

const createUnitTypeReducer = (state) => {
    return { ...state, unitType: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_TYPE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_TYPE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_TYPE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPLOAD_PHOTO_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPLOAD_PHOTO_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPLOAD_PHOTO_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_UNIT_TYPE]: createUnitTypeReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
